import Project from "./Project";
import { Shortlink } from "./Shortlink";
import { Template } from "./Template";

export enum QrCodeTypes {
    ONE_SHOT = "ONE_SHOT",
    MULTI_VIDEO = "MULTI_VIDEO"
}

export interface QrCodeObject {
    shortlink: Shortlink;
    project: Project;
    template: Template;
    isBurnt: boolean;
    currentVideoUrl: string;
    currentAudioUrl: string;
    currentPhotos: string[];
    isThankYouEmailAllowed: boolean;
    isThankYouEmailSent: boolean;
}

export interface TextsData {
    fr: {
        success: {
            doneMultiVideo: string;
        };
    };
    en: {
        success: {
            doneMultiVideo: string;
        };
    };
}
